import script from "./StudentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentPage.vue?vue&type=script&setup=true&lang=js"

import "./StudentPage.vue?vue&type=style&index=0&id=e775e9c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e775e9c0"]])

export default __exports__